/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetAssignmentAnswers400Response,
  GetEnterpriseSystemSettings200Response,
} from '../models/index';
import {
    GetAssignmentAnswers400ResponseFromJSON,
    GetAssignmentAnswers400ResponseToJSON,
    GetEnterpriseSystemSettings200ResponseFromJSON,
    GetEnterpriseSystemSettings200ResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class SystemApi extends runtime.BaseAPI {

    /**
     * システムの設定情報を取得します。
     * システム設定取得
     */
    async getEnterpriseSystemSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEnterpriseSystemSettings200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/system/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEnterpriseSystemSettings200ResponseFromJSON(jsonValue));
    }

    /**
     * システムの設定情報を取得します。
     * システム設定取得
     */
    async getEnterpriseSystemSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEnterpriseSystemSettings200Response> {
        const response = await this.getEnterpriseSystemSettingsRaw(initOverrides);
        return await response.value();
    }

}
